import { useBreakpoints } from '@vueuse/core'

export default () => {
  const breakpoints = useBreakpoints({
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  })

  return breakpoints
}
